import React from "react";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import TitleSection from "../title-section";
import Slider from "react-slick";
import contentfulRenderOptions from "../../../utils/contentfulRenderOption";

//Styles
import "./testimonials.scss";

const Testimonials = (props: ReferenciaContenido) => {
    const {
        tituloGeneral,
        referenciaPlantillaContenido,
    } = props;

    const settingsCarousel = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "34px",
        arrows: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    return (
        <div className="m-testimonials">
            <TitleSection title={tituloGeneral} />
            <div className="m-testimonials__container">
                {window.innerWidth <= 768 ?
                    <Slider {...settingsCarousel}>
                        {referenciaPlantillaContenido?.map((item, index) => (
                            <div className="card" key={index}>
                                <div className="card__top">
                                    <img className="card__top__image" src={item.imagenPrincipal[0].file.url}/>
                                    <h3 className="card__top__name">{item.tituloBanner}</h3>
                                </div>
                                {item.descripcion &&
                                    <p className="card__testimonial">{contentfulRenderOptions(item.descripcion.json)}</p>
                                }
                            </div>
                        ))}
                    </Slider>
                :
                    <>
                        {referenciaPlantillaContenido?.map((item, index) => (
                            <div className="card" key={index}>
                                <div className="card__top">
                                    <img className="card__top__image" src={item.imagenPrincipal[0].file.url}/>
                                    <h3 className="card__top__name">{item.tituloBanner}</h3>
                                </div>
                                {item.descripcion &&
                                    <p className="card__testimonial">{contentfulRenderOptions(item.descripcion.json)}</p>
                                }
                            </div>
                        ))}
                    </>
                }
            </div>
        </div>
    );
};

export default Testimonials;